module.exports = __webpack_public_path__ + "img/renkou.61f12e69.png";